import { buildPeriodQuery } from '../compareHelpers/periodQuery'

// AI-CONTEXT: See docs/features/deep-analysis-period.md
// AI-CONTEXT: See docs/pitfalls.md#routing-url-built-here-read-by-position-there
//
// The path into the deep analysis of one anchor, with the card's period as
// query. One builder for every way in — the 'Diepte-analyse' icon and the
// clickable card title — so the two can never send the user somewhere
// different. The page reads type and id by position (Location()[3]/[4]); the
// period travels as query, never as an extra path segment.

/**
 * @param {string} client - Tenant id (first path segment)
 * @param {'effect'|'research'|'activity'} type - Anchor type
 * @param {string} id - Anchor entity ID
 * @param {import('../compareHelpers/periodQuery').CardPeriodValue|null} [periodValue] - The card's chosen period
 * @returns {string}
 */
const deepAnalysisPath = (client, type, id, periodValue = null) =>
    `/${client}/deepanalysis/${type}/${id}${buildPeriodQuery(periodValue)}`

export default deepAnalysisPath
